// Format numeric date FR : 24/02/2026
export function formatDateNumericFR(date: string | Date | null): string {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Format Date-Heure FR Abrégé : 24 févr. 2026, 13:09
export function formatDateTimeAbbreviatedFr(
  date?: string | Date | null,
): string {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Format Date FR Abrégé : 24 aug. 2025
export function formatDateAbbreviatedFr(date: string) {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// Format Date FR Abrégé : 24 aout 2025
export function formatDateFullFr(date: string) {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

// Format Date relative FR : Il y a 4 min
export function formatDateTimeRelative(d?: string | Date | null): string {
  if (!d) return "Jamais";
  const diffMs = Date.now() - new Date(d).getTime();
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return "À l'instant";
  if (mins < 60) return `Il y a ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `Il y a ${hours}h`;
  const days = Math.floor(hours / 24);
  return `Il y a ${days} jour${days > 1 ? "s" : ""}`;
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function isDateInPast(date: Date | string): boolean {
  return new Date(date) < new Date();
}
